import * as flightNetwork from "./flightNetworks";
import * as googleMaps from "./googleMaps";
import * as profile from "./profile";
import * as profileUpdateRequest from "./profileUpdateRequest";

const oversight = {
  ...flightNetwork,
  ...googleMaps,
  ...profile,
  ...profileUpdateRequest,
}

export default oversight